export const OutIcon = ({ color }) => {
  return (
    <path
      d="M16.5845 8.55375L7.25175 17.877C7.11325 18.0153 6.93925 18.0829 6.72975 18.0798C6.52008 18.0766 6.346 18.0058 6.2075 17.8673C6.06917 17.7288 6 17.5563 6 17.35C6 17.1437 6.06917 16.9713 6.2075 16.8328L15.5307 7.5H7.3345C7.122 7.5 6.94383 7.42808 6.8 7.28425C6.65633 7.14042 6.5845 6.96225 6.5845 6.74975C6.5845 6.53708 6.65633 6.359 6.8 6.2155C6.94383 6.07183 7.122 6 7.3345 6H17.1805C17.4367 6 17.6513 6.08658 17.8245 6.25975C17.9978 6.43308 18.0845 6.64775 18.0845 6.90375V16.75C18.0845 16.9625 18.0126 17.1406 17.8688 17.2843C17.7249 17.4281 17.5468 17.5 17.3343 17.5C17.1216 17.5 16.9434 17.4281 16.7998 17.2843C16.6562 17.1406 16.5845 16.9625 16.5845 16.75V8.55375Z"
      fill={color}
    />
  )
}
